import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { Grid, Text } from '@mantine/core'
import React from 'react'

import { Icon } from '../../../../src'
import { Container, SpacedIconRight } from './DropdownItem.styles'
import type { IDropdownItemBase } from './DropdownItem.types'

export const DropdownItem: React.FC<
  React.PropsWithChildren<IDropdownItemBase>
> = ({
  children,
  startIcon,
  endIcon,
  iconColor,
  onClick,
  endIconSpace,
  selected,
  startAdorment,
  endAdorment,
  description,
  disabled = false,
  tooltipId,
  ...rest
}) => {
  const handleClick = () => {
    if (!disabled) {
      onClick?.()
    }
  }

  return (
    <div>
      <Container
        disabled={disabled}
        role='button'
        data-testid='flectoui--dropdown-item'
        onClick={handleClick}
        {...rest}
      >
        {startIcon && (
          <div style={{ marginRight: '8px' }}>
            <Icon color={iconColor} icon={startIcon} />
          </div>
        )}
        {startAdorment && (
          <div style={{ marginRight: '8px' }}>{startAdorment}</div>
        )}

        <Grid>
          <Text>{children}</Text>
        </Grid>

        {endIcon && !endIconSpace && <Icon color={iconColor} icon={endIcon} />}
        {endIcon && endIconSpace && (
          <SpacedIconRight>
            <Icon color={iconColor} icon={endIcon} />
          </SpacedIconRight>
        )}
        {selected && (
          <SpacedIconRight>
            <Icon color='brand' icon={faCheck} />
          </SpacedIconRight>
        )}
        {endAdorment && <div style={{ marginLeft: '8px' }}>{endAdorment}</div>}
      </Container>
    </div>
  )
}

export default DropdownItem
